<template>
  <v-btn-form :title="title" @close="cancel()">
       <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 py-3>
              Для импорта данных, выберите файл (xlsx, csv), содержащий обязательные  колонки: <b>
              инн физ. лица, фамилия, имя, отчество</b> и дополнительные колонки: <b> пол, дата рождения, снилс, номер паспорта РФ, инн компании, должность, телефон, email, адрес.</b>
            </v-flex>
            <v-layout align-center>
            <v-flex xs8 sm6>
            <template v-for="item in files">
              <div><v-tooltip bottom open-delay="500" max-width="20em">
              <div slot="activator">
              <v-chip
                :key = item.name
                small
                :text-color="errorFileMessage(item) ? 'error' : 'black'"
                @click="pickFile"
                close
                @input="item.remove"
                >
                <span class="text-xs-center">
                  {{item.name.slice(0, 30)}}
                </span>
              </v-chip>
                </div>
                <span style="overflow-wrap: break-word">{{item.name}}</span>
                <div class="error" light>{{errorFileMessage(item)}}</div>
              </v-tooltip></div>
              </template>
              <v-chip
                small
                text-color="secondary"
                @click="pickFile"
                @keydown.enter="pickFile"
                v-show="files.length === 0"
                >
                <span class="text-xs-center">
                Выберите файл для импорта
                </span>
              </v-chip>
              <input
                type="file"
                style="display: none"
                ref="image"
                @change="onFilePicked"
                :accept="getAcceptedFileFormat()"
                multiple
              >
            </v-flex>
          </v-layout>
            </v-layout>
            <v-flex py-3>
              Уточните соответствие атрибутов записи о физ.лице и колонок в загружаемом файле
            </v-flex>
          <v-layout column>
            <b>
              <v-layout row align-center>
                <v-flex xs3 sm3 >
                <span>Атрибут</span>
                </v-flex>
                <v-flex xs6 sm4 px-2>
                <span>Название колонки</span>
                </v-flex>
                <v-flex xs3 sm4 px-2 >
                <span>Пример значения</span>
                </v-flex>
              </v-layout>
            </b>
              <template v-for="item in fields">
              <v-layout row align-center>
              <v-flex xs3 sm3 >
              <span>{{item.label}}</span>
              </v-flex>
              <v-flex xs6 sm4 px-2>
              <v-select
                hide-details
                v-model="item.number"
                :items="getNewFields()"
                item-value="value"
                item-text="text"
              >
              </v-select>
              </v-flex>
              <v-flex xs4 sm4 px-2 >
              <span>{{getValue(item)}}</span>
              </v-flex>
            </v-layout>
            </template>
          </v-layout>
          <v-flex py-3>
            При импорте данных происходит проверка формата, если данные не удовлетворяют формату, то они не записываются в систему. <br/>Для более точной настройки укажите форматы следующих данных:
          </v-flex>
          <v-flex xs8 sm6>
            <v-select
              label="Муж/Жен"
              v-model="genderFormat"
              :items="[
                {value: 'MF', text: 'Муж.(M)/Жен.(F)'},
                {value: '01', text: 'Муж.(0)/Жен.(1)'},
                {value: '12', text: 'Муж.(1)/Жен.(2)'}
              ]"
            >
            </v-select>
          </v-flex>
          <v-flex xs8 sm6>
            <v-select
              label="Формат дат"
              v-model="dateFormat"
              :items="[
                {value: 'YYYY-MM-DD', text: 'гггг-мм-дд'},
                {value: 'DD/MM/YYYY', text: 'дд/мм/гггг'},
                {value: 'DD.MM.YYYY', text: 'дд.мм.гггг'}
              ]"
            >
            </v-select>
          </v-flex>
      </v-card-text>
    <template #actions>
      <v-btn :disabled='!arrData || arrData.length === 0' @click="ok">ОК</v-btn>
      <v-spacer></v-spacer>
    </template>  
  </v-btn-form>  
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import files from '../../api/files'
  import dialogs from '../common/dialogs'
  import client from '../client/index.js'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'people-loader',
    components: {vBtnForm},
    data: () => ({
      files: [],
      fields: [
        {name: 'innfl', label: 'ИНН Физ. лица', number: 0},
        {name: 'lastName', label: 'Фамилия', number: 1},
        {name: 'firstName', label: 'Имя', number: 2},
        {name: 'middleName', label: 'Отчество', number: 3},
        {name: 'sex', label: 'Пол', number: 4},
        {name: 'birthday', label: 'Дата рождения', number: 5},
        {name: 'birthplace', label: 'Место рождения', number: 6},
        {name: 'snils', label: 'СНИЛС', number: 7},
        {name: 'sernum', label: 'Серия номер паспорта РФ', number: 8},
        {name: 'issuer', label: 'Организация выдавшая документ', number: 9},
        {name: 'issued', label: 'Дата выдачи', number: 10},
        {name: 'issuerCode', label: 'Код подразделения', number: 11},
        {name: 'passportAddress', label: 'Адрес регистрации', number: 12},
        {name: 'companyInn', label: 'ИНН компании', number: 13},
        {name: 'position', label: 'Должность', number: 14},
        {name: 'phone', label: 'Телефон', number: 15},
        {name: 'email', label: 'Эл. почта', number: 16},
        {name: 'address', label: 'Адрес', number: 17}
      ],
      genderFormat: 'MF',
      dateFormat: 'YYYY-MM-DD',
      textData: null,
      arrData: null,
      test: null,
      selectedIds: []
    }),
    mounted () {
    },
    watch: {
      textData: function (newVal, oldVal) {
        this.updateArrData()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
      }),
      title () {
        return 'Импорт данных о Физ. лицах'
      }
    },
    methods: {
      errorFileMessage (file) {
        return files.errorFileMessage(file)
      },
      getAcceptedFileFormat () {
        return '.csv, .xlsx'
      },
      pickFile () {
        this.$refs.image.click()
      },
      onFilePicked (e) {
        const fs = Array.from(e.target.files)
        if (fs.length > 0) {
          fs.forEach((f) => files.readFileAsByteArray(f, (bytes) => {
            this.addFile(f, bytes)
          }))
        }
      },
      addFile (f, data) {
        const cb = (bytes) => {
          f.remove = (e) => !e && this.deleteFile(f)
          this.files = [f]
          this.textData = bytes
        }
        const cbErr = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при экспорте данных из файла '})
        }
        files.convertToCsv(f, data, cb, cbErr)
      },
      deleteFile (file) {
        this.files = this.files.filter(f => formats.compareString(f.name, file.name) !== 0)
      },
      getNewFields () {
        let result = [{value: null, text: '(не задано)'}]
        if (this.arrData && this.arrData[0]) {
          this.arrData[0].forEach((value, key) => {
            result.push({value: key, text: value})
          })
        }
        return result
      },
      getValue (item) {
        return this.arrData && this.arrData[1] ? this.arrData[1][item.number] : ''
      },
      import (fields, data) {
        let map = []
        fields.forEach(f => {
          map[f.name] = f.number
        })
        const _g = (rec, name) => map[name] !== null ? rec[map[name]] : null
        const _d = (v) => {
          if (!v) return null
          let result = null
          let ms = null
          switch (this.dateFormat) {
            case 'YYYY-MM-DD':
              ms = /^((?:19|20)\d\d)-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[0,1])$/.exec(v)
              result = ms ? `${ms[1]}-${ms[2]}-${ms[3]}` : null
              break
            case 'DD/MM/YYYY':
              ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\/(0[1-9]|1[012])\/((?:19|20)\d\d)$/.exec(v)
              result = ms ? `${ms[3]}-${ms[2]}-${ms[1]}` : null
              break
            case 'DD.MM.YYYY':
              ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\.(0[1-9]|1[012])\.((?:19|20)\d\d)$/.exec(v)
              result = ms ? `${ms[3]}-${ms[2]}-${ms[1]}` : null
              break
          }
          console.log('_d', v, result)
          return result
        }
        const _s = (v) => {
          if (!v) return null
          switch (this.genderFormat) {
            case 'MF': return /^F|M$/.test(v) ? v : null
            case '01': return /^0|1$/.test(v) ? (/^0$/.test(v) ? 'M' : 'F') : null
            case '12': return /^1|2$/.test(v) ? (/^1$/.test(v) ? 'M' : 'F') : null
          }
          return null
        }
        const _inn = (v) => !v ? null : (formats.isInn(v) ? v : null)
        const _innfl = (v) => !v ? null : (formats.isInnfl(v) ? v : null)
        const _snils = (v) => {
          if (!v) return null
          if (formats.isSnils(v)) return v
          let s = v.split(/-|\s/).join('')
          if (formats.isSnils(s)) return s
          return null
        }
        const _sernum = (v) => {
          if (!v) return null
          if (/^\d{4}\s\d{6}$/.test(v)) return v
          if (/^\d{4}\d{6}$/.test(v)) return `${v.slice(0, 4)} ${v.slice(4)}`
        }
        const _name = (v) => {
          if (!v) return null
          if (formats.isNameRu(v, 60)) return v
          return null
        }
        const _camelName = (v) => {
          return `${v.slice(0, 1).toUpperCase()}${v.slice(1).toLowerCase()}`
        }
        const _nameCanonic = (v) => {
          if (!v) return null
          if (formats.isNameRu(v, 60)) {
            let s = v
            v.split(/-|\s/).forEach(w => {
              s = s.replace(w, _camelName(w))
            })
            return s
          }
          return null
        }
        // const _p = (v) => //
        let result = []
        data.forEach((r, index) => {
          if (index !== 0 && _g(r, 'lastName')) {
            result.push({
              individual: {lastName: _nameCanonic(_g(r, 'lastName')), firstName: _nameCanonic(_g(r, 'firstName')), middleName: _nameCanonic(_g(r, 'middleName')), innfl: _innfl(_g(r, 'innfl')), birthday: _d(_g(r, 'birthday')), sex: _s(_g(r, 'sex')), snils: _snils(_g(r, 'snils')), address: _g(r, 'passportAddress')},
              contact: {companyInn: _inn(_g(r, 'companyInn')), position: _g(r, 'position'), phone: _g(r, 'phone'), email: _g(r, 'email'), address: _g(r, 'address')},
              doc: _sernum(_g(r, 'sernum')) ? {
                type: 'PASSPORT_RF',
                model: JSON.stringify({modelType: '21.01', surname: _name(_g(r, 'lastName')), firstname: _name(_g(r, 'firstName')), patronymic: _name(_g(r, 'middleName')), sernum: _sernum(_g(r, 'sernum')), birthday: _d(_g(r, 'birthday')), sex: _s(_g(r, 'sex')), issuer: _g(r, 'issuer'), issued: _d(_g(r, 'issued')), issuerCode: _g(r, 'issuerCode'), address: _g(r, 'passportAddress'), birthplace: _g(r, 'birthplace')
                })
              } : null
            })
          }
        })
        return this.addRefCode(result)
        .then(dtos => this.$store.dispatch('updatePeopleIndividuals', {dtos: dtos}))
      },
      addRefCode (dtos) {
        return new Promise((resolve, reject) => {
          let inns = new Set()
          dtos.forEach(dto => {
            if (dto.contact && dto.contact.companyInn) {
              inns.add(dto.contact.companyInn)
            }
          })
          client.convertInnToRefCode(inns)
            .then(map => {
              dtos.forEach(dto => {
                if (dto.contact && dto.contact.companyInn && map[dto.contact.companyInn]) {
                  dto.contact['companyRefCode'] = map[dto.contact.companyInn]
                }
              })
              resolve(dtos)
            })
        })
      },
      ok () {
        var result = this.arrData
        console.log('ok', result)
        dialogs.confirm(this,
          'Подтвердите',
          `Загрузить данные о Физ. лицах (${result.length - 1})?`,
          (self) => {
            this.import(this.fields, result).then(() => dialogs.message(this, 'Импорт', 'Данные загружены на сервер'))
            this.$emit('input', result)
            this.cancel()
          })
      },
      cancel () {
        this.$emit('close')
        this.item = null
      },
      updateArrData () {
        let arrData = files.parseCsv(files.decode(this.textData))
        // skip empty lines
        while (arrData.length > 0 && (arrData[0].join('').length === 0)) {
          arrData.shift()
        }
        this.arrData = arrData
      }
    }

  }

</script>




// WEBPACK FOOTER //
// PeopleLoader.vue?5cc4220d